import React, { useEffect } from 'react';
import { initAppToast } from './appToast';

/** AntApp 내부에서 전역 message 설정 */
const AppToastInit: React.FC = () => {
  useEffect(() => {
    initAppToast();
  }, []);
  return null;
};

export default AppToastInit;
